import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { useCallback } from 'react'
import { v4 as uuid } from 'uuid'

export const useGAPurchase = ({ productId }: { productId: string }) => {
  const { data: product } = useQuery({
    ...queries.products.detail(productId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
  const { data: session } = useSession()

  const gaPurchase = useCallback(() => {
    if (!product) return

    const transactionId = `purchase-${uuid()}`

    window.dataLayer?.push({ ecommerce: null })
    window.dataLayer?.push({
      event: 'purchase',
      ecommerce: {
        currency: 'KRW',
        transaction_id: transactionId,
        value: product.price.price,
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            price: product.price.price,
          },
        ],
      },

      page_title: document.querySelector('title')?.innerText || '',
      page_url: window.location.href,
      user_id: session?.user.dto.id,
      login_status: true,
    })
  }, [product, session])

  return { gaPurchase }
}
